<palantir-dialog title="SUPER DEBUG - Configuração de Logs">
  <div palantir-dialog-content class="palantir-scrollbar flex flex-col gap-6">
    <!-- Padrões Ativos -->
    <div class="flex flex-col gap-3">
      <palantir-text type="subtitle">Padrões Ativos</palantir-text>
      <div
        class="flex min-h-[56px] flex-wrap gap-2 rounded-lg border border-neutral-200 bg-neutral-50 p-4"
      >
        @if (patternList().length === 0) {
          <palantir-text type="text" class="italic text-neutral-500">
            Nenhum padrão ativo. Logs estão desabilitados.
          </palantir-text>
        } @else {
          @for (pattern of patternList(); track pattern) {
            <div
              class="flex items-center gap-2 rounded-full border border-blue-200 bg-blue-100 px-3 py-1"
            >
              <span class="text-xs font-semibold text-blue-700">{{ pattern }}</span>
              <palantir-button
                (click)="removePattern(pattern)"
                title="Remover padrão"
                theme="transparent"
                layout="icon"
                size="2xs"
                icon="remove-outline"
                variant="negative"
              >
              </palantir-button>
            </div>
          }
        }
      </div>
    </div>

    <!-- Adicionar Novo Padrão -->
    <div class="flex flex-col gap-3">
      <palantir-text type="subtitle">Adicionar Padrão</palantir-text>
      <div class="flex gap-2">
        <palantir-input class="flex-1">
          <input
            placeholder="Ex: app:*, -auth:*, *#error"
            [ngModel]="newPatternInput()"
            (ngModelChange)="newPatternInput.set($event)"
            name="newPattern"
            (keyup.enter)="addPattern()"
          />
        </palantir-input>
        <palantir-button (click)="addPattern()" theme="solid" variant="positive">
          Adicionar
        </palantir-button>
      </div>
      <palantir-text type="description" class="text-neutral-400">
        Use <code>*</code> para wildcard, <code>-</code> para excluir e <code>#</code> para nível.
      </palantir-text>
    </div>

    <!-- Presets -->
    <div class="flex flex-col gap-3">
      <palantir-text type="subtitle">Sugestões Rápidas</palantir-text>
      <div class="flex flex-wrap gap-2">
        @for (preset of presets; track preset.value) {
          <palantir-button
            size="xs"
            theme="outline"
            variant="neutral"
            (click)="applyPreset(preset.value)"
          >
            {{ preset.label }} ({{ preset.value }})
          </palantir-button>
        }
      </div>
    </div>

    <!-- Ações Rápidas -->
    <div class="mt-2 flex gap-3 border-t border-neutral-100 pt-6">
      <palantir-button theme="outline" variant="negative" (click)="disableAll()" class="flex-1">
        Limpar Tudo
      </palantir-button>
      <palantir-button theme="solid" variant="positive" (click)="enableAll()" class="flex-1">
        Habilitar Tudo (*)
      </palantir-button>
    </div>
  </div>
</palantir-dialog>
